const CuKalpha = {
  name: 'CuKalpha',
  value: 0.15406,
  label: 'Cu K\u03B1',
  unit: 'nm',
};

const Fe = {
  name: 'Fe',
  value: 0.19373,
  label: 'Fe',
  unit: 'nm',
};

const Co = {
  name: 'Co',
  value: 0.17902,
  label: 'Co',
  unit: 'nm',
};

const MoKalpha = {
  name: 'MoKalpha',
  value: 0.07107,
  label: 'Mo K\u03B1',
  unit: 'nm',
};

const LIST_WAVE_LENGTH = [
  CuKalpha, Fe, Co, MoKalpha,
];

export {
  LIST_WAVE_LENGTH,  // eslint-disable-line
};
